const values = {
    "HOME": "Inicio",
}

export default values;